import template from './print-all-registrations.html';

class PrintAllRegistrationsComponent {
  constructor($log, $rootScope, $window) {
    'ngInject';
    this.$log = $log;
    this.$rootScope = $rootScope;
    this.$window = $window;
  }

  print() {
    this.$window.open(
      '/SCR/schoolCommonRoom/' + this.$rootScope.me.schoolCommonRoomId + '/attendances/registrations' +
      '?printPdf=true' +
      '&orderBy=lastname,firstname' +
      '&orderType=asc',
      '_blank'
    );
  }
}

export const PrintAllRegistrations = {
  bindings: {
    disabled: '<'
  },
  controller: PrintAllRegistrationsComponent,
  template
};
